import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);


const baseStyle = definePartsStyle({
  control: {
    borderColor: 'black',
    borderRadius: 4,
  }
});

const sm = definePartsStyle({
  control: {
    width: '14px',
    height: '14px'
  }
});

const readOnly = definePartsStyle({
  control: {
    cursor: 'default',
    bg: 'red.500',
    borderColor: 'red.500',
    _checked: {
      bg: 'teal.400',
      borderColor: 'teal.400',
      _hover: {
        bg: 'teal.400',
        borderColor: 'teal.400',
      },
    }
  }
});

const disabled = definePartsStyle({
  control: {
    cursor: 'default',
    bg: 'gray.400',
    borderColor: 'gray.400',
    _checked: {
      _disabled: {
        color: 'white',
        bg: 'teal.400',
        borderColor: 'teal.400',
      }
    },
    _disabled: {
      opacity: 1,
      bg: 'gray.400',
      borderColor: 'gray.400',
    }
  }
});

export const Checkbox = defineMultiStyleConfig({
  baseStyle,
  sizes: {
    sm
  },
  defaultProps: {
    size: 'sm'
  },
  variants: {
    disabled,
    readOnly
  }
});